import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useDidUpdate } from 'rooks';

//After the unmounting hook fires onClose in case the modal open flag is regulated by redux.
export default function useModalCloseOnNavigate(onClose: () => void) {
  const location = useLocation();

  useDidUpdate(() => {
    //When the path changes, it works.
    onClose();
    // eslint-disable-next-line
  }, [location.pathname]);

  useEffect(() => {
    return () => {
      onClose();
    };
    // eslint-disable-next-line
  }, []);

  return null;
}
